<template>
  <blacklisted-contacts />
</template>

<script>
import BlacklistedContacts from "@/components/3pl/CRM/CustomerEngagement/BlacklistedContacts";
export default {
  components: {
    BlacklistedContacts,
  },
};
</script>

<style></style>
